<template>
  <div>

    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster' }">工作通</el-breadcrumb-item>
        <el-breadcrumb-item>招标</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <!-- logo -->
    <div class="top">
      <div>
        <img
          src="@/assets/community/back.png"
          class="top-left-img"
          @click="back"
        />
      </div>
      <div>
        <img src="@/assets/tender/tender.png" alt="" class="top-midlle-img" />
      </div>
      <div class="top-midlle-span">招标记录</div>
    </div>
    <!-- 中间 -->
    <div class="middle">
      <!-- 左半部分 -->
      <div class="middle-left">
        <!-- 选择器 -->
        <div class="selector">
          <el-select v-model="searchFormData.link" placeholder="请选择" clearable="">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 搜索 -->
        <div class="seach">
          <el-input v-model="searchFormData.title" placeholder="请输入招标名称"></el-input>
          <el-button type="primary" @click="onSearch()">搜索</el-button>
        </div>
      </div>
      <!-- 右半部分 -->
      <div class="middle-right">
        <!-- <router-link :to="'/personal-work-other-my-tender-submit'"> -->
        <!-- <el-button plain @click="gotosub()">提交记录</el-button> -->
        <!-- </router-link> -->
        <el-button type="primary" @click="gotoRelease">发布招标</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="bottom">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="title" label="标题" width="150">
        </el-table-column>
        <el-table-column prop="description" label="简介" width="255">
        </el-table-column>
        <el-table-column prop="tb_num" label="投标" width="110"> </el-table-column>
        <el-table-column prop="zb_num" label="中标" width="110"> </el-table-column>
        <el-table-column prop="tt_num" label="淘汰" width="110">
        </el-table-column>
        <el-table-column prop="wrap_status" label="状态" width="110">
          <template slot-scope="{row}">
            <!--1招标中2待选标3选标完成4已结束-->
            <span v-if="row.wrap_status == 1" style="color: #1BD17E;">招标中</span>
            <span v-else-if="row.wrap_status == 2" style="color: #FF9004;">待选标</span>
            <span v-else-if="row.wrap_status == 3" style="color: #FF4E4E;">选标完成</span>
            <span v-else style="color: #FF4E4E;">已结束</span>
          </template>  
        </el-table-column>

        <el-table-column
          label="操作"
          fixed="right"
          align="center"
          class-name="small-padding fixed-width"
          width="100"
        >
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="detail(scope.row.crowd_id)">
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="searchFormData.page"
        :page-size="searchFormData.limit"
        layout="total, prev, pager, next"
        :total="searchFormData.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { webCrowdList } from "@/api/director/package/index";
export default {
  data() {
    return {
      options: [
        {
          value: "1",
          label: "进行中",
        },
        {
          value: "2",
          label: "待选标",
        },
        {
          value: "3",
          label: "已结束",
        },
      ],
      searchFormData: {
        title: "",
        corpor_id: "", //	社团id
        mode: 1, //1招标列表，2帮忙列表
        link: "", //	1进行中，2待选标，3已结束
        page: 1, //页数
        limit: 10, //	每页条数
        total: 0,
      },
      tableData: [],
    };
  },

  mounted() {
    if (this.$route.query.corpor_id != "") {
      this.searchFormData.corpor_id = this.$route.query.corpor_id;
      this.fetchData();
      // 获取接口
    }

  },
  methods: {
    onSearch(){
      this.fetchData();
    },
    fetchData() {
      webCrowdList(this.searchFormData).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.tableData = res.data.data;
          this.searchFormData.total = res.data.total;
        } else {
          this.$message.error(res.msg ? res.msg : "请求错误");
        }
      });
    },
    gotoRelease() {
      this.$router.push( { name: "bidding-release", query: { corpor_id: this.searchFormData.corpor_id } } );

    },

    detail(crowd_id) {
      this.$router.push( { name: "bidding-detail", query: { crowd_id: crowd_id} } );

    },
     // 当前页变更
     handleCurrentChange(num) {
      this.searchFormData.page = num;
      this.fetchData();
    },

    // 每页显示页面数变更
    handleSizeChange(size) {
      this.searchFormData.limit = size;
      this.fetchData();
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  width: 950px;
  height: 31px;
  display: flex;
}

.top-left-img {
  margin-top: 8px;
  width: 25px;
  height: 25px;
}

.top-midlle-img {
  width: 40px;
  height: 40px;
}

.top-midlle-span {
  margin-left: 20px;
  margin-top: 8px;
  height: 16px;
  font-size: 16px;
  color: #181818;
  font-weight: bold;
}

.top-right {
  margin-top: 2px;
  margin-left: 740px;
}

.middle {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;

  .middle-left {
    display: flex;

    .selector {
      width: 100px;
      height: 28px;
      margin-left: 25px;
    }

    ::v-deep .el-input__inner {
      color: #181818;
    }

    .seach {
      // width: 192px;
      // height: 28px;
      display: flex;
      margin-left: 19px;

      .el-button--small {
        margin-left: 13px;
      }
    }
  }
}

.middle[data-v-cc741ad6] {
  width: 100%;
}

.bottom {
  margin-top: 26px;
  margin-left: 25px;
}

.paging {
  margin-top: 50px;
  display: flex;
  justify-content: flex-end;
}

.middle-right {
  display: flex;
  justify-content: space-between;
}
</style>
